import React from 'react';
import CurrencyInputComponent from './CurrencyInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
}
const CurrencyInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  switch (null) {
    default:
      return <CurrencyInputComponent question={question} />;
  }
};

export default CurrencyInputPicker;
